import { render, staticRenderFns } from "./item-card.vue?vue&type=template&id=6f65132c&scoped=true&"
import script from "./item-card.vue?vue&type=script&lang=js&"
export * from "./item-card.vue?vue&type=script&lang=js&"
import style0 from "./item-card.vue?vue&type=style&index=0&id=6f65132c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65132c",
  null
  
)

export default component.exports